import { render, staticRenderFns } from "./Quick-Project.vue?vue&type=template&id=336bd6d5"
import script from "./Quick-Project.vue?vue&type=script&lang=js"
export * from "./Quick-Project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports